import { render } from "./AddArtikelEvent.vue?vue&type=template&id=febb03fe"
import script from "./AddArtikelEvent.vue?vue&type=script&lang=js"
export * from "./AddArtikelEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__